import React from 'react';

interface ContentProps {
  children: React.ReactNode;
  className?: string;
}

const Content: React.FC<ContentProps> = ({ children, className }) => {
  return (
    <div
      className={`
            w-[90%]
            mx-[auto]
            ${className || ''}
            `}
    >
      {children}
    </div>
  );
};

export default Content;
